export default "__VITE_ASSET__OXfR$J42__"